var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24V21.3333H0V18.6667H2.66667V5.33333H0V2.66667H4V0H6.66667V2.66667H9.33333V0H12V2.83333C13.1556 3.14444 14.1111 3.77222 14.8667 4.71667C15.6222 5.66111 16 6.75556 16 8C16 8.64444 15.8889 9.26111 15.6667 9.85C15.4444 10.4389 15.1333 10.9667 14.7333 11.4333C15.5111 11.9 16.1389 12.5333 16.6167 13.3333C17.0944 14.1333 17.3333 15.0222 17.3333 16C17.3333 17.4667 16.8111 18.7222 15.7667 19.7667C14.7222 20.8111 13.4667 21.3333 12 21.3333V24H9.33333V21.3333H6.66667V24H4ZM5.33333 10.6667H10.6667C11.4 10.6667 12.0278 10.4056 12.55 9.88333C13.0722 9.36111 13.3333 8.73333 13.3333 8C13.3333 7.26667 13.0722 6.63889 12.55 6.11667C12.0278 5.59444 11.4 5.33333 10.6667 5.33333H5.33333V10.6667ZM5.33333 18.6667H12C12.7333 18.6667 13.3611 18.4056 13.8833 17.8833C14.4056 17.3611 14.6667 16.7333 14.6667 16C14.6667 15.2667 14.4056 14.6389 13.8833 14.1167C13.3611 13.5944 12.7333 13.3333 12 13.3333H5.33333V18.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/BitcoinIcon.2a2907096fb494c2ba364c0692f800dd.svg";
export { ForwardRef as ReactComponent };